import { create } from "zustand";

interface ChatState {
  // Indicateur de frappe
  isTyping: boolean;
  setIsTyping: (typing: boolean) => void;

  // Saisie courante
  currentInput: string;
  setCurrentInput: (input: string) => void;
  addToCurrentInput: (input: string) => void;

  // État de soumission
  isSubmitting: boolean;
  setIsSubmitting: (submitting: boolean) => void;

  // Modale de fin
  showCompletionModal: boolean;
  setShowCompletionModal: (show: boolean) => void;

  // État d'enregistrement audio
  isRecording: boolean;
  setIsRecording: (recording: boolean) => void;

  // État de transcription audio
  isTranscribing: boolean;
  setIsTranscribing: (transcribing: boolean) => void;

  // Transcription tracking - nombre de caractères transcrits dans le message en cours
  transcribedLength: number;
  setTranscribedLength: (length: number) => void;
  addTranscribedLength: (length: number) => void;
  resetTranscribedLength: () => void;

  // Reset
  reset: () => void;
}

export const useChatStore = create<ChatState>((set, get) => ({
  isTyping: false,
  setIsTyping: (typing) => set({ isTyping: typing }),

  currentInput: "",
  setCurrentInput: (input) => set({ currentInput: input }),
  addToCurrentInput: (input) =>
    set({ currentInput: get().currentInput + " " + input }),

  isSubmitting: false,
  setIsSubmitting: (submitting) => set({ isSubmitting: submitting }),

  showCompletionModal: false,
  setShowCompletionModal: (show) => set({ showCompletionModal: show }),

  isRecording: false,
  setIsRecording: (recording) => set({ isRecording: recording }),

  isTranscribing: false,
  setIsTranscribing: (transcribing) => set({ isTranscribing: transcribing }),

  transcribedLength: 0,
  setTranscribedLength: (length) => set({ transcribedLength: length }),
  addTranscribedLength: (length) =>
    set({ transcribedLength: get().transcribedLength + length }),
  resetTranscribedLength: () => set({ transcribedLength: 0 }),

  reset: () =>
    set({
      isTyping: false,
      currentInput: "",
      isSubmitting: false,
      showCompletionModal: false,
      isRecording: false,
      isTranscribing: false,
      transcribedLength: 0,
    }),
}));
